import { render, staticRenderFns } from "./BaseTrabajadores.vue?vue&type=template&id=f8a85aee&scoped=true&"
import script from "./BaseTrabajadores.vue?vue&type=script&lang=js&"
export * from "./BaseTrabajadores.vue?vue&type=script&lang=js&"
import style0 from "./BaseTrabajadores.vue?vue&type=style&index=0&id=f8a85aee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a85aee",
  null
  
)

export default component.exports